/*import React, { useState, useEffect } from "react";
import axios from "axios";

const Latestnews = () => {
  const [latestNews, setLatestNews] = useState([]);

  useEffect(() => {
    const fetchLatestNews = async () => {
      try {
        const response = await axios.get(
          "https://arabic-news-api.p.rapidapi.com/cnnarabic",
          {
            headers: {
              "x-rapidapi-key": "21de8334e4msh1a4aea180805afbp1a7f42jsn6060c3c961db", // Replace with your actual API key
              "x-rapidapi-host": "arabic-news-api.p.rapidapi.com",
            },
          }
        );

        // Sort news by published date in descending order
        const sortedNews = response.data.results.sort(
          (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
        );
        // Update state with the latest three news articles
        setLatestNews(sortedNews.slice(0, 3));
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchLatestNews();
  }, []);

  return (
    <div className="news-container">
      <h1 className="title">أحدث الأخبار</h1>
      <div className="news-grid">
        {latestNews.map((article, index) => (
          <div key={index} className="news-card">
            {article.image && (
              <img
                src={article.image}
                alt={article.headline}
                className="news-image"
              />
            )}
            <div className="news-content">
              <h2 className="news-title">
                {article.headline || "No Title"}
              </h2>
              <p className="news-description">
                {article.underHeadline || "No Description"}
              </p>
              <p className="news-date">
                <strong>Date:</strong> {article.date || "Unknown"}
              </p>
              <a
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="news-link"
              >
                Read more
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Latestnews;
*/

/*import { Link } from "react-router-dom";
import React  from "react";
import "./Latestnews.css";



const Latestnews = () => {
  const articles = [
    {
      id: 1,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/04/9/2434093-1374784281.jpeg?itok=FKYjveHu",
      title: "تنفيذ جولات رقابية في السعودية لضمان الامتثال للتشريعات العقارية ونظام الوساطة",
      author: "Akari",
      date: "April 2025",
      description:
        "شهدت السعودية جولات رقابية في شهر مارس شملت زيارة 86 منشأة عقارية في كل من الرياض والشرقية ومكة، وتأتي الجولات بهدف ضمان الامتثال للتشريعات العقارية بشكل عام ونظام الوساطة العقارية بشكل خاص، إضافة إلى تطبيق نظام التوطين.",
        link:"https://www.aleqt.com/2025/02/18/article_2757332.html",
    },
    {
      id: 2,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/04/15/2434396-1425898568.jpeg?itok=sMlHttQY",
      title: "أسعار العقارات في السعودية ترتفع 4.3 % خلال الربع الأول بضغط السكنية",
      author: "Akari",
      date: "April 2025",
      description:"ارتفاع متوسط اسعار العقارات في السعودية 4.3% خلال الربع الأول من عام 2025 على أساس سنوي بضغط من نمو أسعار العقارات السكنية 5.1% والتجارية 2.5%، فيما انخفضت أسعار الزراعية 2.5%، وفقا لبيانات الهيئة العامة للإحصاء الصادرة اليوم.الرض سجلت أعلى ارتفاع سنوي في أسعار العقارات بـ10.7% خلال الربع الأول، تليها مكة المكرمة بـ1.5% أما الشرقية فسجلت أكبر تراجع في الأسعار بـ5.5% لتكون الأعلى انخفاضا بين مناطق السعودية وفقا للبيانات" ,
        link:"https://www.aleqt.com/2025/02/18/article_2757332.html",
    },
    {
      id: 3,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/02/27/2431858-1157295127.jpeg?itok=Y29wP51X",
      title: "اتفاقية تمويل عقاري توسع فرص تملك المواطنين للمساكن في السعودية",
      author: "ADMIN",
      date: "March 2025",
      description:
        "وقعت الشركة السعودية لإعادة التمويل العقاري، التابعة لصندوق الاستثمارات العامة، اتفاقية مع البنك الأهلي التجاري السعودي لشراء محفظة تمويل عقاري بقيمة 3.4 مليار ريال، في واحدة من أكبر عمليات إعادة التمويل العقاري في السعودية.",
        link:"https://www.aleqt.com/2025/02/18/article_2757332.html"
    },
  ]
  return (
    
    <div className="blog-container">
      <h2 className="blog-heading">أخبار ومقالات العقارات</h2>
      <p className="blog-subheading">كن على اطلاع دائم بأحدث أخبارنا ومقالاتنا</p>
      <div className="blog-grid">
        {articles.map((article) => (
          <div key={article.id} className="blog-card">
          <Link>
            <img src={article.image} alt={article.title} className="blog-image" />
            </Link>
            <div className="blog-content">
              <h3>{article.title}</h3>
              <p className="blog-meta">
                Posted By <span>{article.author}</span> | {article.date}
              </p>
              <p>{article.description}</p>
              <a href="">
                <button>Read More</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
   
  );
};

export default Latestnews;
*/
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Latestnews.css";

const Latestnews = () => {
    const [topBlogs, setTopBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get("https://baseapis.akari.sa/api/Blog/GetBlogs");
                const topThree = response.data.slice(0, 3); // Take first 3 blogs
                setTopBlogs(topThree);
            } catch (error) {
                console.error("Failed to fetch top blogs:", error);
            }
        };

        fetchBlogs();
    }, []);

    return (
         <div className="blog-list">
                    <h2>أحدث منشورات المدونة</h2>
                    <div className="blog-cards">
                        {topBlogs.map((blog) => (
                            <div key={blog.id} className="blog-card">
                                <Link to={`/blogdetails/${blog.id}`}>
                                    {blog.image && (
                                        <img src={blog.image} alt="Banner" className="blog-image" />
                                    )}
                                </Link>
                                <h3>{blog.title}</h3>
                                <div
                                    className="blog-content"
                                    dangerouslySetInnerHTML={{ __html: blog.content.slice(0, 150) + "..." }}
                                />
                                <p><strong>تاريخ-</strong> {blog.category}</p>
                                <Link to={`/blogdetails/${blog.id}`} className="read-more">اقرأ المزيد</Link>
                            </div>
                        ))}
                    </div>
                </div>
    );
};

export default Latestnews;
